// extracted by mini-css-extract-plugin
export default {"KeyPad":"style_KeyPad__L9ebt"};